var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useEffect, useState } from 'react';
import { api_service } from '../../../api/api_service';
import { api_urls } from '../../../api/api_urls';
import { ACKNOWLEDGE_CATEGORY, DOCUMENT_TYPE_OPTIONS } from '../utils/documentTypes';
var NON_ACTIONABLE_ACTION_TYPE = 'NON_ACTIONABLE';
var isNonActionable = function (entry) { var _a; return String((_a = entry === null || entry === void 0 ? void 0 : entry.ActionType) !== null && _a !== void 0 ? _a : '').trim().toUpperCase() === NON_ACTIONABLE_ACTION_TYPE; };
var pickText = function (entry, keys) {
    var key = keys.find(function (candidate) { return typeof (entry === null || entry === void 0 ? void 0 : entry[candidate]) === 'string' && entry[candidate].trim(); });
    return key ? String(entry[key]).trim() : '';
};
var rawDocumentType = function (entry) {
    return ['DocumentType', 'DocType', 'DocumentCategory', 'Category', 'Type']
        .map(function (key) { return entry === null || entry === void 0 ? void 0 : entry[key]; })
        .find(function (value) { return value !== undefined && value !== null && String(value).trim() !== ''; });
};
var toDocumentTypeLabel = function (entry) {
    if (isNonActionable(entry))
        return ACKNOWLEDGE_CATEGORY;
    var raw = rawDocumentType(entry);
    if (raw === undefined)
        return '';
    var option = DOCUMENT_TYPE_OPTIONS.find(function (candidate) { return candidate.value === String(raw).trim(); });
    return option ? option.label : (typeof raw === 'string' ? raw.trim() : '');
};
var CONTRACT_STATUS_REASON_TYPE = 'CONTRACT_STATUS';
var isTrue = function (value) { return value === 1 || value === true || String(value).trim() === '1' || String(value).trim().toLowerCase() === 'true'; };
var toReasons = function (list) {
    return list
        .map(function (entry) {
        var _a, _b;
        if (typeof entry === 'string')
            return { id: entry, label: entry };
        var label = pickText(entry, ['Value', 'Description', 'Name', 'Reason', 'Label']);
        var documentType = toDocumentTypeLabel(entry);
        var id = pickText(entry, ['OId', 'Id', 'ReasonOId', 'StatusReasonOId']) || String((_b = (_a = entry === null || entry === void 0 ? void 0 : entry.OId) !== null && _a !== void 0 ? _a : entry === null || entry === void 0 ? void 0 : entry.Id) !== null && _b !== void 0 ? _b : label);
        var rawType = rawDocumentType(entry);
        return label ? __assign(__assign(__assign(__assign(__assign(__assign({ id: id, label: label }, (documentType ? { documentType: documentType } : {})), (rawType !== undefined ? { documentTypeCode: String(rawType) } : {})), ((entry === null || entry === void 0 ? void 0 : entry.ActionType) ? { actionType: String(entry.ActionType) } : {})), ((entry === null || entry === void 0 ? void 0 : entry.Source) ? { source: String(entry.Source) } : {})), (isTrue(entry === null || entry === void 0 ? void 0 : entry.IsCustom) ? { isCustom: true } : {})), ((entry === null || entry === void 0 ? void 0 : entry.ReasonOId) !== undefined && (entry === null || entry === void 0 ? void 0 : entry.ReasonOId) !== null && String(entry.ReasonOId).trim() !== '' ? { reasonOId: String(entry.ReasonOId).trim() } : {})) : null;
    })
        .filter(function (reason) { return reason !== null; });
};
export var useDocsBackReasons = function (enabled) {
    var _a = useState([]), reasons = _a[0], setReasons = _a[1];
    var _b = useState(false), isLoading = _b[0], setIsLoading = _b[1];
    var _c = useState(false), hasFailed = _c[0], setHasFailed = _c[1];
    var _d = useState(false), hasLoaded = _d[0], setHasLoaded = _d[1];
    useEffect(function () {
        if (!enabled)
            return undefined;
        var cancelled = false;
        setIsLoading(true);
        setHasFailed(false);
        setHasLoaded(false);
        api_service
            .get({ endPoint: api_urls.GET_STATUS_REASONS, payLoad: { ReasonType: CONTRACT_STATUS_REASON_TYPE }, showLoader: false })
            .then(function (res) {
            var _a, _b, _c, _d, _e;
            if (cancelled)
                return;
            if (((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.statusCode) !== 200) {
                setHasFailed(true);
                return;
            }
            var list = (_e = [(_c = (_b = res === null || res === void 0 ? void 0 : res.data) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.StatusReasons, (_d = res === null || res === void 0 ? void 0 : res.data) === null || _d === void 0 ? void 0 : _d.data, res === null || res === void 0 ? void 0 : res.data].find(function (candidate) { return Array.isArray(candidate); })) !== null && _e !== void 0 ? _e : [];
            var mapped = toReasons(list);
            setReasons(mapped);
        })
            .catch(function () { if (!cancelled)
            setHasFailed(true); })
            .finally(function () { if (!cancelled) {
            setIsLoading(false);
            setHasLoaded(true);
        } });
        return function () { cancelled = true; };
    }, [enabled]);
    return { reasons: reasons, isLoading: isLoading, hasFailed: hasFailed, hasLoaded: hasLoaded };
};
